import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Container from "@/components/containers/Container";

import UserList from "../../../components/settings/users/UserList";

export const Route = createFileRoute("/admin/_panel/_settings/settings/users")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation("core.shared");

  return (
    <Container title={t("Users")} description="">
      <UserList />
    </Container>
  );
}
